import i18next, { use, init } from "i18next";
import { initReactI18next } from "react-i18next";
import { homeResources } from "../components/home/.resources";
import { navigationResources } from "../components/navigation/.resources";
import { legalResources } from "../components/navigation/legal/.resources";
import { accountResources } from "../components/account/my-account/.resources";
import { mainComponentsResources } from "../components/.resources";
import { licenseDialogsResources } from "../components/account/my-licenses/dialogs/.resources";
import { myLicensesResources } from "../components/account/my-licenses/.resources";
import { myFileResources } from "../components/account/my-products/my-file/.resources";
import { myProductsResources } from "../components/account/my-products/.resources";
import { myPurchasesResources } from "../components/account/my-purchases/.resources";
import { docsResources } from "../components/docs/.resources";
import { purchasingFaqResources } from "../components/faq/purchasingFaq/.resources";
import { weighbridgeResources } from "../components/products/weighbridge/.resources";
import { productsResources } from "../components/products/.resources";
import { servicesResources } from "../components/services/.resources";

// Import all your resource files here
const resources = {
  en: {
    home: homeResources.en,
    navigation: navigationResources.en,
    legal: legalResources.en,
    account: accountResources.en,
    main: mainComponentsResources.en,
    licenseDialogs: licenseDialogsResources.en,
    myLicenses: myLicensesResources.en,
    myFile: myFileResources.en,
    myProducts: myProductsResources.en,
    myPurchases: myPurchasesResources.en,
    docs: docsResources.en,
    purchasingFaq: purchasingFaqResources.en,
    weighbridge: weighbridgeResources.en,
    products: productsResources.en,
    services: servicesResources.en,
    // Add other namespaces as you migrate more resource files
  },
  es: {
    home: homeResources.es,
    navigation: navigationResources.es,
    legal: legalResources.es,
    account: accountResources.es,
    main: mainComponentsResources.es,
    licenseDialogs: licenseDialogsResources.es,
    myLicenses: myLicensesResources.es,
    myFile: myFileResources.es,
    myProducts: myProductsResources.es,
    myPurchases: myPurchasesResources.es,
    docs: docsResources.es,
    purchasingFaq: purchasingFaqResources.es,
    weighbridge: weighbridgeResources.es,
    products: productsResources.es,
    services: servicesResources.es,
    // Add other namespaces as you migrate more resource files
  },
};

use(initReactI18next);

init({
  resources,
  lng: "en", // default language
  fallbackLng: "en",

  interpolation: {
    escapeValue: false, // React already does escaping
  },

  // Optional: namespace configuration
  defaultNS: "home",
  ns: ["home", "navigation", "legal", "account", "main", "licenseDialogs", "myLicenses", "myFile", "myProducts", "myPurchases", "docs", "purchasingFaq", "weighbridge", "products", "services"],
});

export default i18next;
